import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7e96273d: FaireBrandEntity = {
  token: "b_7e96273d",
  type: "brand",
  name: "Lucky Jack",
  avatarUrl:
    "https://cdn.faire.com/fastly/f9b43aa7b744bc4cb4013100a2bf6c027f28fa37a0b3b9a50a2d0b950b189c78.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/4d73667a513e2935ea27e85c81d52f7942e6f2a9a0968bd05b5339c9c7c3fe76.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/f9b43aa7b744bc4cb4013100a2bf6c027f28fa37a0b3b9a50a2d0b950b189c78.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4d73667a513e2935ea27e85c81d52f7942e6f2a9a0968bd05b5339c9c7c3fe76.jpeg",
  location: "Portland, OR, USA",
  minimumOrderDollars: 0,
  rating: 4.9,
  reviewCount: 601,
  isTopShop: true,
  isInsider: true,
  description:
    'Lucky Jack (formerly know as Trixie & Milo) was started for those who live to explore, enjoy fixing things with their own hands, and take pride in every adventure, big or small. Owners Milo and Trixie, a husband-and-wife duo, share a deep love for the great outdoors, and a passion for craftsmanship that can stand the test of time.\n\n“Lucky” Jack Jones, Milo’s grandfather, was a true legend whose globe-trotting escapades were as wild as the stories he brought home with him. Whether he was fixing a steam engine deep in the Amazon, or charming a princess into a royal tour, "Lucky" Jack Jones tackled life with grit, wit, and a big heart.\n\nThat same spirit drives the design and intention of every piece of gear.',
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:48.137Z",
    importedBy: "entity-db-cli",
  },
};
